import React from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useQuote } from '../../hooks';
import StatePanel from '../../../components/ui/StatePanel';
import QuoteView from './QuoteView';

const Quote = ({ item, id, onQuoteSaved, navigateOnSave, basePath }) => {
  const quoteId = id === 'new' ? id : parseInt(id, 10);
  const { quote, isLoading, isError } = useQuote(quoteId);
  const queryClient = useQueryClient();

  // A failed load (5xx / dropped connection) used to render an EMPTY quote
  // form for a quote that exists — and saving it could overwrite the real one
  // with blanks. Show a retry instead.
  if (isError && !quote) {
    return (
      <StatePanel
        state="error"
        compact
        title="Couldn't load this quote"
        description="Something went wrong on our side — try again."
        onRetry={() => queryClient.refetchQueries({ queryKey: ['quote', quoteId] })}
      />
    );
  }

  return (
    <QuoteView
      {...{
        id,
        item,
        isLoading,
        quote,
        onQuoteSaved,
        navigateOnSave,
        basePath,
      }}
    />
  );
}

export default Quote;
